import { HandySvg } from "handy-svg";
import { useRef, useState } from "react";
import useClickOutside from "../../../utils/hooks/useClickOutside";

const NumberOfOutputsList = [
	{ name: "1", value: 1 },
	{ name: "2", value: 2 },
	{ name: "3", value: 3 },
	{ name: "4", value: 4 },
];

const NumberOfOutputsSelector = ({ style, activeItem, dictionary, changeSettings }) => {
	const [listISOpen, setListISOpen] = useState(false);
	const itemRef = useRef(null);

	const listClose = () => setListISOpen(false);

	const listToggle = () => setListISOpen(!listISOpen);

	const selectItem = (item) => {
		listClose();
		changeSettings(item, "num_results");
	};

	useClickOutside(itemRef, listClose);

	const numberOfImagesText = (number) => (number === "1" ? dictionary["image"] || "image" : dictionary["images"] || "images");

	return (
		<div ref={itemRef} className={style["number"]}>
			<button className={style["number_outputs"]} onClick={listToggle} type="button" id="outputs-toggle">
				{activeItem.name} {numberOfImagesText(activeItem.name)}
				<HandySvg src={"/workspace/profile/profile_arrow.svg"} width={13} height={8} className={style.number_outputs_icon} />
			</button>
			<div id="outputs-list" className={`${style["drop-down-list"]} ${listISOpen ? style["open"] : style["close"]}`}>
				{NumberOfOutputsList.map((item, index) => {
					if (item.value === activeItem.value) return null;
					if (index === 1) {
						return (
							<button id="output-btn" className={style["drop-down-list_item"]} type="button" key={index} onClick={() => selectItem(item)} style={{ whiteSpace: "nowrap", minWidth: "fit-content" }}>
								<span>
									{item.name} {numberOfImagesText(item.name)}
								</span>
							</button>
						);
					}
					return (
						<button className={style["drop-down-list_item"]} type="button" key={index} onClick={() => selectItem(item)} style={{ whiteSpace: "nowrap", minWidth: "fit-content" }}>
							<span>
								{item.name} {numberOfImagesText(item.name)}
							</span>
						</button>
					);
				})}
			</div>
		</div>
	);
};

const NumberOfOutputsCounter = ({ style, activeItem, dictionary, isLoading, changeSettings }) => {
	const minus = () => {
		if (activeItem.value > 1) changeSettings({ name: (activeItem.value - 1).toString(), value: activeItem.value - 1 }, "num_results");
	};

	const plus = () => {
		if (activeItem.value < 4) changeSettings({ name: (activeItem.value + 1).toString(), value: activeItem.value + 1 }, "num_results");
	};

	return (
		<div className={style["number"]}>
			<p className={style[`title`]}>{dictionary["number_outputs"] || "Number of outputs"}</p>
			<div className={style["number_counter"]}>
				<button aria-label="minus" onClick={minus}>
					<HandySvg src={"/ico/minus.svg"} width={30} height={30} className={style.number_outputs_icon} />
				</button>
				<span>{activeItem.value}</span>
				<button aria-label="plus" onClick={plus}>
					<HandySvg src={"/ico/plus.svg"} width={30} height={30} className={style.number_outputs_icon} />
				</button>
			</div>
		</div>
	);
};

export { NumberOfOutputsSelector, NumberOfOutputsCounter };
